import * as React from 'react';
import { StyledVideoPlayer } from './styles';
import UserAgentUtils from '../../utils/userAgent';

interface VideoPlayerProps {
	url: string;
}

class VideoPlayer extends React.Component<VideoPlayerProps, {}> {
	videoElement: HTMLVideoElement;

	render() {
		const { url } = this.props;
		const isChrome = UserAgentUtils.isChrome();

		return (
			<StyledVideoPlayer
				ref={(video: HTMLVideoElement) => {
					this.videoElement = video;
					if (video && isChrome) {
						this.videoElement.setAttribute('controlsList', 'nodownload');
					}
				}}
				controls={true}
				autoPlay={true}
			>
				<source src={url}/>
			</StyledVideoPlayer>
		);
	}
}

export default VideoPlayer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/VideoPlayer/index.tsx